import type {
  BffCartAddress,
  BffShoppingCart,
} from '@/core/models/bff-shopping-carts';

const STORAGE_KEY = 'checkoutCartSnapshot';
const REDIRECT_IN_PROGRESS_KEY = 'checkoutRedirectInProgress';

export type CheckoutCartSnapshot = {
  cartId: string;
  products: { id: string; quantity: number }[];
  subscriptions: { id: string; quantity: number }[];
  shippingAddress: BffCartAddress | null;
  billingAddress: BffCartAddress | null;
};

function isBrowser(): boolean {
  return typeof window !== 'undefined';
}

export function saveCheckoutCartSnapshot(cart: BffShoppingCart): void {
  if (!isBrowser()) return;
  if (!cart.products.length && !cart.subscriptions.length) return;

  const snapshot: CheckoutCartSnapshot = {
    cartId: cart.id,
    products: cart.products.map(p => ({ id: p.id, quantity: p.quantity })),
    subscriptions: cart.subscriptions.map(s => ({
      id: s.id,
      quantity: s.quantity,
    })),
    shippingAddress: cart.shippingAddress,
    billingAddress: cart.billingAddress,
  };

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
}

export function getCheckoutCartSnapshot(): CheckoutCartSnapshot | null {
  if (!isBrowser()) return null;

  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as CheckoutCartSnapshot;
  } catch {
    return null;
  }
}

export function hasCheckoutCartSnapshot(): boolean {
  return getCheckoutCartSnapshot() !== null;
}

export function clearCheckoutCartSnapshot(): void {
  if (!isBrowser()) return;
  sessionStorage.removeItem(STORAGE_KEY);
}

/** Set while Adyen `submitDetails` is resolving an iDEAL/redirect return. */
export function setCheckoutRedirectInProgress(): void {
  if (!isBrowser()) return;
  sessionStorage.setItem(REDIRECT_IN_PROGRESS_KEY, '1');
}

export function clearCheckoutRedirectInProgress(): void {
  if (!isBrowser()) return;
  sessionStorage.removeItem(REDIRECT_IN_PROGRESS_KEY);
}

export function isCheckoutRedirectInProgress(): boolean {
  if (!isBrowser()) return false;
  return sessionStorage.getItem(REDIRECT_IN_PROGRESS_KEY) === '1';
}
